(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flux-download"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Mirrors the platform detection on fluxkeyboard.com/updates.
    // ?platform=windows|macos|deb|rpm|none forces a state for testing.
    const detect = () => {
      const forced = new URLSearchParams(location.search).get('platform');
      if (forced) return ['windows', 'macos', 'deb', 'rpm'].includes(forced) ? forced : null;

      const ua = navigator.userAgent || '';
      const platform = navigator.userAgentData?.platform || navigator.platform || '';
      const hay = `${platform} ${ua}`.toLowerCase();
      if (hay.includes('win')) return 'windows';
      if (hay.includes('mac')) return 'macos';
      // Android is Linux-based but has no desktop build; don't claim one
      if (hay.includes('android')) return null;
      if (hay.includes('linux') || hay.includes('x11')) return 'deb';
      return null;
    };

    const mb = (bytes) => `${(bytes / 1048576).toFixed(1)} MB`;

    // Newest of a list of dotted version strings
    const newest = (versions) =>
      versions.slice().sort((a, b) => {
        const x = a.split('.').map(Number);
        const y = b.split('.').map(Number);
        for (let i = 0; i < Math.max(x.length, y.length); i++) {
          const d = (y[i] || 0) - (x[i] || 0);
          if (d) return d;
        }
        return 0;
      })[0];

    const getJSON = (url) =>
      fetch(url, { cache: 'no-store' }).then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      });

    // Each loader resolves to { version, size, url }, read from the same
    // manifests the Polymath updaters use
    const loaders = (base) => {
      const linux = (kind) =>
        getJSON(`${base}/linux/${kind}/updat.json`).then((m) => {
          const e = (m.versions || [])[0];
          if (!e) throw new Error('no versions');
          return { version: m.latest_version_display || e.version_display, size: mb(e.file_size_bytes), url: e.download_url };
        });
      return {
        windows: () =>
          getJSON(`${base}/windows/manifest.json`).then((m) => {
            const v = newest(Object.keys(m.versions || {}));
            const e = m.versions[v];
            if (!e?.fileName) throw new Error('no installer');
            return { version: v, size: mb(e.sizeBytes), url: `${base}/windows/versions/${v}/${e.fileName}` };
          }),
        macos: () =>
          fetch(`${base}/macos/appcast.xml`, { cache: 'no-store' })
            .then((r) => {
              if (!r.ok) throw new Error(r.status);
              return r.text();
            })
            .then((xml) => {
              const enc = new DOMParser().parseFromString(xml, 'application/xml').querySelector('item enclosure');
              if (!enc) throw new Error('no enclosure');
              return {
                version: enc.getAttribute('sparkle:shortVersionString') || enc.getAttribute('sparkle:version') || '',
                size: mb(Number(enc.getAttribute('length') || 0)),
                url: enc.getAttribute('url'),
              };
            }),
        deb: () => linux('deb'),
        rpm: () => linux('rpm'),
      };
    };

    class PolymathDownloads extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        const mine = detect();
        const button = this.querySelector('[data-primary-button]');
        const meta = this.querySelector('[data-primary-meta]');
        const release = this.querySelector('[data-primary-release]');
        const row = mine && this.querySelector(`.polymath__row[data-platform="${mine}"]`);

        // Promote the detected platform into the hero. Its row is lifted out
        // of the list, keeping every remaining row identical.
        if (row) {
          const icon = row.querySelector('.polymath__os-icon')?.cloneNode(true);
          if (icon) button.append(icon);
          button.append(document.createTextNode(this.dataset.downloadFor.replace('%PLATFORM%', row.dataset.name)));
          button.href = row.querySelector('[data-download]').getAttribute('href');
          button.hidden = false;

          this.querySelector('[data-primary-requirements]').textContent = row.querySelector('[data-requirements]').textContent;
          this.querySelector('[data-primary-history]').href = row.querySelector('[data-history]').getAttribute('href');
          if (row.dataset.version) {
            release.textContent = [`${this.dataset.version} ${row.dataset.version}`, row.dataset.size].filter(Boolean).join('  ·  ');
          }
          meta.hidden = false;

          row.remove();
          this.querySelector('[data-others-label]').textContent = this.dataset.alsoAvailable;
        }

        const base = this.dataset.manifestBase;
        if (!base) return;

        const load = loaders(base);
        for (const key of Object.keys(load)) {
          load[key]()
            .then((info) => {
              if (!info.version || !info.url?.startsWith('https://') || !(parseFloat(info.size) > 0)) {
                throw new Error('incomplete manifest');
              }
              if (key === mine) {
                button.href = info.url;
                release.textContent = `${this.dataset.version} ${info.version}  ·  ${info.size}`;
                return;
              }
              const li = this.querySelector(`.polymath__row[data-platform="${key}"]`);
              if (!li) return;
              li.querySelector('[data-download]').href = info.url;
              li.querySelector('[data-release]').textContent = `${info.version}  ·  ${info.size}`;
            })
            .catch(() => {
              // Keep the versions stored in the theme
            });
        }
      }
    }

    if (!customElements.get('polymath-downloads')) customElements.define('polymath-downloads', PolymathDownloads);
  })();

  } catch(e) { console.error(e); }
})();
})();
